import { Dispatch, ThunkAction } from '../../../../../../../types/actions';
import { root } from '../../../../../../../store/constants';
import { APP_INDEX, DEMO_UTM_APP } from 'app/const';
import { segmentTrackAction, SegmentUserEvent } from 'app/middlewares/segment';

export const onClick = (
): ThunkAction => (
    dispatch: Dispatch,
) => {
    dispatch(segmentTrackAction(SegmentUserEvent.DEMO_BUTTON_SIGNUP));
    let amp_device_id = '';
    try {
        const w = window as any;
        amp_device_id = w.amplitude.getInstance().options.deviceId;
    } catch (e) {}
    root.location.href = APP_INDEX + 'dashboard' + DEMO_UTM_APP + amp_device_id;
};
